import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { FinancialDocumentRow } from 'src/features/financialDocumentRows/utils/types';
import { FinancialDocumentRowFormSchemaValues } from 'src/features/financialDocumentRows/utils/formSchema';

const RESOURCE = '/financial-documents/financial-document-row/';

type MutationFnType = typeof mutationFn;

interface DTO extends FinancialDocumentRowFormSchemaValues {
    financial_document: string;
}

const mutationFn = ({ ...data }: DTO): Promise<FinancialDocumentRow> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateFinancialDocumentRow };
